<template>
  <div class='tagViewBk' ref="scrollContainer" @wheel.prevent="handleScroll">
    <i class="postAb el-icon-arrow-left" @click="handleSw('left')"></i>
    <div class="_scroll" ref="scrollWrapper" :style="{left: left + 'px'}">
      <span class="el-tag" v-for="(tag, index) in tagViews" :key="index" @click="handleClick(tag)" :class="{'active': $route.path === tag.path}">{{tag.name}}<i class="el-tag__close el-icon-close" @click.stop="removeList(tag, index)"></i></span>
    </div>
    <i class="postAb el-icon-arrow-right" @click="handleSw('right')"></i>
  </div>
</template>
<script>
const padding = 15
export default {
  data () {
    return {
      left: 0,
      topClick: false,
      currTag: {}
    }
  },
  computed: {
    tagViews () {
      return this.$store.state.tagView
    }
  },
  created () {
    this.$watch('$route', (n, o) => {
      this.$nextTick(() => {
        if(!document.querySelector('.active')){
          return
        }
        const ww = this.$refs.scrollContainer.offsetWidth
        const wl = document.querySelector('.active').offsetLeft
        if (wl > ww && !this.topClick) {
          this.left = -((wl + 120) - ww)
          this.topClick = false
        }
        if(!this.topClick){
          if(wl < ww){
            this.left = 0
            this.topClick = false
          }
        }
        // tagviews click
        if(this.topClick){
          this.topClick = false
          this.$emit('postMessages', this.currTag)
        }
      })
    })
  },
  methods: {
    handleScroll (e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 3
      const $container = this.$refs.scrollContainer
      const $containerWidth = $container.offsetWidth
      const $wrapper = this.$refs.scrollWrapper
      const $wrapperWidth = $wrapper.offsetWidth

      if (eventDelta > 0) {
        this.left = Math.min(0, this.left + eventDelta)
      } else {
        if ($containerWidth - padding < $wrapperWidth) {
          if (this.left < -($wrapperWidth - $containerWidth + padding)) {
            this.left = this.left
          } else {
            this.left = Math.max(this.left + eventDelta, $containerWidth - $wrapperWidth - padding)
          }
        } else {
          this.left = 0
        }
      }
    },
    moveToTarget ($target) {
      const $container = this.$refs.scrollContainer
      const $containerWidth = $container.offsetWidth
      const $targetLeft = $target.offsetLeft
      const $targetWidth = $target.offsetWidth

      if ($targetLeft < -this.left) {
        // tag in the left
        this.left = -$targetLeft + padding
      } else if ($targetLeft + padding > -this.left && $targetLeft + $targetWidth < -this.left + $containerWidth - padding) {
        // tag in the current view
        // eslint-disable-line
      } else {
        // tag in the right
        this.left = -($targetLeft - ($containerWidth - $targetWidth) + padding)
      }
    },
    handleClick (item) {
      this.topClick = true
      this.currTag = item
      // console.log('handleClick', item)
      if (item.labelName && item.labelName.length) {
        this.$store.commit('SET_BREADCRUMBS', item.labelName.split(','))
      } else {
        this.$store.commit('SET_BREADCRUMBS', [])
      }
      this.$router.push({
        path: item.path
      })
    },
    removeList (item, index) {
      let preItemI = index
      if (this.tagViews.length > 1) {
        const preItem = this.tagViews[index - 1]
        this.$store.commit('SET_REMOVE_TAGVIEW', index)
        if(this.$route.path === item.path){
          this.handleClick(preItem)
        }
      }
    },
    handleSw (ty) {
      const aw = this.$refs.scrollContainer
      const w = this.$refs.scrollWrapper
      const minW = (w.offsetWidth - aw.offsetWidth) > 0 ? ((w.offsetWidth - aw.offsetWidth) + 20) : 0
      const px = minW >= 100 ? 100 : minW
      // console.log(aw.offsetWidth, w.offsetWidth, px)
      if (ty == 'right') {
        const left = (this.left - px)
        this.left = (left <= -minW) ? -minW : left
      } else {
        const left = (this.left + px)
        this.left = (left >= 0) ? 0 : left
      }
    }
  }
}
</script>
<style lang="scss" scope>
.tagViewBk {
  height: 40px;
  padding-top: 10px;
  position: fixed;
  top: 60px;
  right: 20px;
  width: calc(100% - 260px);
  background-color: #f5f7f9;
  z-index: 99;
  overflow: hidden;
  // overflow-x: auto;
  ._scroll {
    padding-left: 20px;
    position: absolute;
    overflow: hidden;
    white-space: nowrap;
    z-index: 1;
    transition: left 0.1s ease;
  }
  .postAb {
    position: absolute;
    top: 10px;
    font-size: 16px;
    width: 15px;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    color: #999;
    background-color: #fff;
    z-index: 2;
    &:hover {
      color: #222;
    }
  }
  .el-icon-arrow-left {
    left: 0;
    text-align: left;
    border-radius: 4px 0 0 4px;
  }
  .el-icon-arrow-right {
    right: 0;
    text-align: right;
    border-radius: 0 4px 4px 0;
  }
  /deep/ {
    .el-tag {
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;
      border: 0;
      border-radius: 2;
      line-height: 32px;
      border-radius: 3px;
      margin-right: 10px;
      color: #808695;
      &.active {
        background-color: $color-primary;
        color: #fff;
        border-color: $color-primary;
        .el-icon-close,
        .el-icon-close:hover {
          color: #fff;
        }
      }
    }
    .el-tag .el-icon-close,
    .el-tag .el-icon-close:hover {
      color: #808695;
      background: transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tagView.vue